/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
export function isCentralFioriLaunchpad(): boolean {
    return !!(window && window["sap"] && window["sap"]["cf"]);
}
